import { Component, HostListener, Input } from "@angular/core";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { TechnicalSubmittals_View } from "src/app/pages/projects/sitework/technicalsubmittals/technical-submittals.view.component";
import { DataTable } from "../datatable.component";

@Component({
    standalone: false,
    selector: "column",
    templateUrl: "./datatablecolumn.component.html",
})
export class DataTableColumn {
    @Input() value;
    @Input() header?;
    @Input() options?: ButtonOption[] | string = [];
    @Input() filterOptions?: FilterOption[] = [];
    @Input() editable: boolean = false;
    @Input() type?: DataTableColumnType | string = DataTableColumnType.Text;
    @Input() click?: any;
    @Input() filterable?: boolean = true;
    @Input() sortable?: boolean = true;
    @Input() width?: string;
    @Input() imageWidth?: string;
    @Input() imageHeight?: string;
    @Input() selectionMode?: string = "";
    @Input() styleClass?: string = "";
    @Input() isModal?: boolean = false;
    @Input() modalName?: string = "";
    @Input() format?: string = "yyyy-MM-dd";
    @Input() linkName?: string = null;
    @Input() visible?: boolean = true;
    @Input() min?: any = null;
    @Input() max?: any = null;
    @Input() step?: string = null;
    @Input() required?: boolean | Function = false;
    @Input() mobileFreezeWidth?: number = 768;
    @Input() frozen?: boolean = false;
    @Input() unfrozenOnMobile?: boolean = false;
    @Input() hasOptions?: boolean = false;
    @Input() leftBuffer?: string = null;
    @Input() filter?: boolean = true;
    @Input() numberPipe: string = "1.0";
    @Input() tooltip: string = null;
    @Input() stylingClass: string = null;
    @Input() imageSize: string = null;
    @Input() totalInFooter: boolean = false;
    @Input() disableCheck: number = null;
    @Input() readonlyInput: boolean = true;
    @Input() filterType?: DataTableColumnType | string =
        DataTableColumnType.Text;

    constructor(table: DataTable) {
        table.addColumn(this);
    }

    ngOnInit() {
        if (!this.type) {
            this.type = DataTableColumnType.Text;
        }

        if ("" + this.type != "DropDown" && (this.options || []).length > 0)
            this.styleClass += " dropdown-overflow";

        if (
            "" + this.type == "Thumbnail" &&
            (!this.width || this.width == "initial")
        )
            this.width = "200px";

        if (this.frozen) {
            let isMobileSize = window.innerWidth <= this.mobileFreezeWidth;
            if (isMobileSize) {
                if (!this.unfrozenOnMobile) {
                    this.styleClass += " sticky-column";
                }
            } else {
                this.styleClass += " sticky-column";
            }
        }

        if (
            (this.type == DataTableColumnType.Number ||
                this.type == "Number") &&
            `${this.styleClass}`.indexOf("text-") == -1
        )
            this.styleClass += " text-number";
    }

    @HostListener("window:resize")
    onResize() {
        let isMobileSize = window.innerWidth <= this.mobileFreezeWidth;
        let makeSticky = true;

        if (!this.frozen || (isMobileSize && this.unfrozenOnMobile == true))
            makeSticky = false;

        var styles = this.styleClass.split(" ");

        for (var i = styles.length - 1; i >= 0; i--)
            if (styles[i] == "sticky-column") styles.splice(i, 1);

        if (makeSticky == true) styles.push("sticky-column");

        this.styleClass = styles.join(" ");
    }
}

export enum DataTableColumnType {
    Text = 1,
    ButtonSelect = 2,
    CheckBox = 3,
    Date = 4,
    DropDown = 5,
    Number = 6,
    Options = 7,
    Percentage = 8,
    Textarea = 9,
    Boolean = 10,
    Currency = "Currency",
    SelectBox = "SelectBox",
    Attachments = "Attachments"
}

export class FilterOption {
    label: string;
    value: string;
}

export class ButtonOptions {
    title?: string;
    class?: string;
    controller?: any;
    id?: number;
    hasIcon?: boolean = false;
    icon?: IconDefinition;
    value: string;
    click: (controller: any, id: number, item: any) => void | Promise<void>;
    hide?: (row: any, totalRowCount: number) => boolean;
}
export class ButtonOption extends ButtonOptions {
    suboptions?: ButtonOptions[];
}
